const styles = theme => ({
  titleWrapper: {
    alignItems: 'center',
    display: 'flex',
    marginBottom: theme.spacing.unit * 5
  },
  title: {
    flex: 1
  },
  tableRow: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(12,31,44, 0.04)'
    }
  },
  activateToggle: {
    top: '-2px'
  },
  activateToggleLabel: {
    fontSize: '16px',
    lineHeight: '24px'
  }
});

export default styles;
